import { render, staticRenderFns } from "./CareSpecification.vue?vue&type=template&id=1cc2bc8b&"
import script from "./CareSpecification.vue?vue&type=script&lang=ts&"
export * from "./CareSpecification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports